import { type NonEmptyArray } from './types';

const env = typeof window !== 'undefined' ? window.__QDRANT_CLOUD__.env : 'test';

export const isLocalDevelopmentEnv = env === 'dev';
export const isDevelopmentEnv = env === 'development';
export const isLocalEnv = env === 'local';
export const isProductionEnv = env === 'production';
export const isStagingEnv = env === 'staging';

/**
 * Function to get a random element from an array.
 */
export function getRandomElement<T>(array: readonly T[]): T | undefined {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array.at(randomIndex);
}

export function isNonEmpty<T>(array: T[]): array is NonEmptyArray<T> {
  return array.length > 0;
}

export function isObject(obj: unknown): obj is object {
  return obj != null && typeof obj === 'object';
}

/**
 * This function is used to 'curate' the value to be serialized:
 * - Removes the internal fields from the JSON object that are added by the protobuf library.
 * - Handles BigInt values to be serialized.
 */
// `JSON.stringify` dictates the replacer signature: it is called with every value in the tree.
// oxlint-disable-next-line eslint-js/no-restricted-syntax
export function protobufSerializationReplacer(key: string, value: unknown) {
  if (key === '$unknown' || key === '$typeName') {
    return undefined;
  }
  if (typeof value === 'bigint') {
    return value.toString();
  }
  return value;
}

/**
 * Checks if a path is within a subtree of another path. For example, "configuration.number_of_nodes" is within the subtree of "configuration".
 */
export const isWithinSubtree = (path: string, subtreePath: string) =>
  path === subtreePath || path.startsWith(`${subtreePath}.`);
